import { useAuthRefreshToken } from "@/services/auth";

export const AppLayoutTokenRefresher = () => {
  useAuthRefreshToken();

  return null;
};
